import React from "react";
import { map, range } from "lodash";
import styled from "styled-components";
import { Locale } from "@linkfluence/models/locale";
import Icon from "@ui-kit/icon";
import { tr } from "@radarly/i18n";
import { ReviewClauseLabel } from "@radarly/models/clause/label";
import { LabelNode } from "./index";

const StyledStarIcon = styled(Icon)<{ first?: boolean }>`
  margin-left: 4px;
  margin-right: ${({ first }) => first && "4px"};
`;

const Stars = ({ size }: { size: number }) => (
  <>
    {map(range(0, size), (_, i) => (
      <StyledStarIcon key={i} glyph="star-filled" />
    ))}
  </>
);

export const getReviewLabelNode = (
  type: LabelNode,
  label: ReviewClauseLabel,
  locale?: Locale
) => {
  if (type === "equal") return reviewLabelEqual(label);
  if (type === "from") return reviewLabelFrom(label, locale);
  if (type === "to") return reviewLabelTo(label, locale);
  return reviewLabelDefault(label);
};

const reviewLabelTo = (label: ReviewClauseLabel, locale: Locale) => (
  <>
    {tr(locale, "FACETS::REVIEWRATE::INTERVAL_TO", { to: label.lt })}
    <Stars size={1} />
  </>
);

const reviewLabelFrom = (label: ReviewClauseLabel, locale: Locale) => (
  <>
    {tr(locale, "FACETS::REVIEWRATE::INTERVAL_FROM", { from: label.gt })}
    <Stars size={1} />
  </>
);

const reviewLabelEqual = (label: ReviewClauseLabel) => (
  <>
    {label.gt} <Stars size={1} />
  </>
);

const reviewLabelDefault = (label: ReviewClauseLabel) => (
  <>
    {label.gt} <Stars size={1} />
    &nbsp;&nbsp;-&nbsp;
    {label.lt}
    <Stars size={1} />
  </>
);
